import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { MdErrorOutline } from 'react-icons/md';

import { hooks } from '../hooks';
import { text } from '../text';
import { theme } from '../constants';
import { components } from '../components';
import { useLanguage } from '../context/LanguageContext';

const ErrorOutlineIcon = MdErrorOutline as any;

export const NotFound: React.FC = () => {
  const { pathname } = useLocation();
  const navigate = hooks.useAppNavigate();
  const { t } = useLanguage();

  useEffect(() => {
    setTimeout(() => {
      window.scroll({ top: 0, left: 0, behavior: 'smooth' });
    }, 10);
  }, [pathname]);

  return (
    <div id='screen' style={{ backgroundColor: '#FFFFFF', minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <components.Header goBack={true} />
      <main
        className='container'
        style={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          textAlign: 'center',
          padding: '20px',
          marginTop: -60 // Mengimbangi header agar benar-benar di tengah
        }}
      >
        <div style={{
          width: 120, height: 120, borderRadius: 60, backgroundColor: '#FFF7F2',
          display: 'flex', justifyContent: 'center', alignItems: 'center', marginBottom: 24
        }}>
          <ErrorOutlineIcon size={64} color={theme.colors.mainColor} />
        </div>
        <text.H1 style={{ fontSize: 64, color: theme.colors.mainDark, marginBottom: 8, lineHeight: 1 }}>
          404
        </text.H1>
        <text.H3 style={{ color: theme.colors.mainDark, marginBottom: 16 }}>{t.notFound?.title}</text.H3>
        <text.T16 style={{ color: theme.colors.bodyTextColor, marginBottom: 40, maxWidth: 300, lineHeight: 1.5 }}>
          {t.notFound?.description}
        </text.T16>
        <components.Button
          title={t.notFound?.backToHome}
          onClick={() => navigate('/TabNavigator', { replace: true })}
          containerStyle={{ width: '100%', maxWidth: 300 }}
        />
      </main>
    </div>
  );
};